jQuery(document).ready(function($) {

  /**
   *
   * ACTIONS - LISTENERS
   *
   */

	//Search herbs listener
	$('.js-herbs-filter').submit(function (e) { 
		e.preventDefault();
    search = $('.js-herbs-search').val();
    start_with = $('.js-herbs-alphabet span.active').text();

    filterHerbs(search,start_with);
	});

	//start with alphabet listener {
	$('.js-herbs-alphabet span').click(function (e) { 
    start_with = $(this).text();
    $('.js-herbs-alphabet span').removeClass('active');
    $(this).addClass('active');
    search = $('.js-herbs-search').val(); //zohlednit hledání
    
		filterHerbs(search, start_with);
  });
  
  //reset filter
  $('.js-herbs-filter .fullwsearching__reset').click(function (e) { 
    e.preventDefault();
    $('.js-herbs-alphabet span').removeClass('active');
    $('.js-herbs-search').removeClass('active').val('');
    filterHerbs('', '');
  });



  /**
   *
   * AJAX - SEARCHING
   *
   */

		/* HERBS SEARCHING */
	function filterHerbs(search = '', start_with = '') {

    if(search.length == 0) {
			search = '';
    }
    
    if(start_with.length == 0) {
			start_with = '';
    }
    
    if(search.length == 0 && start_with.length == 0) {
      $('.fullwsearching__reset').removeClass('fullwsearching__reset--active'); //remove reset button
    } else {
      $('.fullwsearching__reset').addClass('fullwsearching__reset--active'); //add reset button
    }

		params = {};
		params.search = search;
    params.start_with = start_with;
    
    $('.fullwsearching__submit').addClass('button-loading').attr('disabled','disabled');
    

		var ajaxUrl =  '/wp-admin/admin-ajax.php';
		$.post(ajaxUrl, {
        action:"filterHerbs_ajax",
        data: params,
        dataType: "json",
		contentType : "application/json;charset=utf-8",
    }).done(function(result_json){
        if(result_json.length) {
					result = jQuery.parseJSON(result_json);
					$('.js-herbs-list').html(result);
        	//console.log(result);
        }
        $('.fullwsearching__submit').removeClass('button-loading').removeAttr('disabled');
    });
	}


});